import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import { LibData } from "../../utils/LibToolsData";
// import { Tab } from "../../pages/tab";// TODO: Remove tab
import { Filter } from "./Filter";
import { FilterUtils, useIsDesktop } from "./FilterUtils";
import { LibraryUtils } from "../LibraryContainer/LibraryUtils";
import { RobotLib } from "../LibraryContainer/RobotLib";
import { ToolLib } from "../LibraryContainer/ToolLib";


let hash_message = {
    "rdkfilter": window.location.hash,
    "rdkinfo": window.location.search,
};
window.addEventListener("message", (event) => {
    if (!window.Settings.LOCAL_BUILD) {
        if(event.data.hasOwnProperty("rdkfilter")) {
            hash_message = {
                "rdkfilter": event.data.rdkfilter,
                "rdkinfo": event.data.rdkinfo
            }
        }
    }
});

let tickApplyFilter = null;

// Local search_params instead of window.location.search
// So that we can store search info without resetting the page
let search_params = {};
let tools_list: any = {};
for (const [k, v] of Object.entries(LibData.DATA_ALL)) {
    if (v["MT"] == "T" && v["T"] == "Tool") {
        tools_list[k] = v
    }
}

// Default brand, type, axes filters
let brandFilter: stringBoolMap = {};
Object.keys(LibData.ListAllBrands).forEach(brand => {  // Purposely using robot brands and not all brands
    brandFilter[brand] = false;
});

let axesFilter: stringBoolMap = {};
Object.keys(LibData.ListAllAxes).forEach(axes => {
    axesFilter[axes] = false
});

let applicationFilter: stringBoolMap = {};
Object.keys(LibData.ListAllApplications).forEach(apps => {
    applicationFilter[apps] = false
});

// Flag to hide tab
const hideTab = window.location.search.includes("HideTab");


export const ToolFilter = () => {
    const { t, i18n } = useTranslation();

    // Init state
    const [init, setInit] = React.useState(true);

    // Filter states
    const [brands, setBrands] = React.useState(brandFilter);
    const [axes, setAxes] = React.useState(axesFilter);

    const [tool_weight, setWeight] = React.useState([LibData.weightMin, LibData.weightMax]);

    const [applications, setApplications] = React.useState(applicationFilter);

    const [sortFilteredTools, setSortFilteredRobots] = React.useState(tools_list);

    // Filter helper states
    const [filterType, setFilterType] = React.useState("instant");
    const [noToolsMessage, setNoToolsMessage] = React.useState("");

    // Helper variables
    let filteredToolCounts = FilterUtils.countCheckboxParameters("tool", sortFilteredTools);

    // weight[1] = (weight[1] >= 6) ? 6 : weight[1]

    const parameters = {
        "brands": brands,
        "axes": axes,
        "tool_weight": tool_weight,
        "applications": applications,
    };

    const setupFilter = (url_data: any) => {
        //if (url_data["rdkinfo"] != "") {
        if (url_data["rdkinfo"]) {
            let info = url_data["rdkinfo"].replace("%27", "'").split("+").join(" ");

            info.substring(1).split("&").map((param) => {
                param.split("?").map((p) => {
                    let temp = p.split("=");
                    search_params[temp[0]] = temp[1];
                });
            });
        };

        const default_filter_map = {
            "brand": brandFilter,
            "axes": axesFilter,
            "tool_weight": [LibData.toolWeightMin, LibData.toolWeightMax],
            "application": applicationFilter,
        };
        const filter_set_map = {
            "brand": setBrands,
            "axes": setAxes,
            "tool_weight": setWeight,
            "application": setApplications,
        }

        FilterUtils.extractUrlQueryOnMessage("tool", url_data["rdkfilter"]);

        // Apply filters
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(FilterUtils.extracted_params.hasOwnProperty("name"))
            search_input.value = FilterUtils.extracted_params['name'];

        Object.keys(FilterUtils.extracted_params).map((key) => {
            if(key != "name") {
            // if(key != "name" && key != "n") {
                editFilterFromUrl(
                    FilterUtils.extracted_params[key],
                    default_filter_map[key],
                    filter_set_map[key]
                )
            }
        })
        
        setFilterType("instant");
    };

    const editFilterFromUrl = (
        extracted_param: any,
        default_filter: any,
        set_filter: any,
    ) => {
        if(Array.isArray(default_filter)) {
            const [min, max] = [
                parseFloat(extracted_param[0]),
                parseFloat(extracted_param[1])
            ];
            
            set_filter([
                min < default_filter[0] ? default_filter[0] : min,
                max > default_filter[1] ? default_filter[1] : max
            ]);
            setFilterType("instant");
        } else {
            let cloned_filter = structuredClone(default_filter);
            Object.keys(cloned_filter).map((entry) => {
                if(extracted_param.includes(entry.toLowerCase()))
                    cloned_filter[entry] = true;
            });

            set_filter(cloned_filter);
            setFilterType("instant");
        }
    }

    // filter methods
    const applyFilters = () => {
        tickApplyFilter = null;

        if (search_params.hasOwnProperty("oem")) {
            tools_list = {};
            
            Object.entries(LibData.DATA_ALL).map((item) => {
                const [name, robot] = [item[0], item[1]];
                if (robot.hasOwnProperty("B")) {
                    if (search_params["oem"].toLowerCase() == robot["B"].toLowerCase())
                        tools_list[name] = robot;
                }
            });
        };

        // let filtered_list = LibData.DATA_ALL;
        let filtered_list: any = tools_list;
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(search_input.value.length > 0)
            filtered_list = LibraryUtils.searchWithItemsList("tool", filtered_list);

        for(const key in parameters) {
            let temp = FilterUtils.applyFiltersToList("tool", key, parameters[key], filtered_list);

            if(Object.keys(temp).length > 0)
                filtered_list = temp;

            // If parameter is of type range then take the result even when it's empty
            if(["tool_weight"].includes(key) && FilterUtils.rangeFilterChangedFromDefault(key, parameters[key]))
                filtered_list = temp;
        }

        filteredToolCounts = FilterUtils.countCheckboxParameters("tool", filtered_list);

        applyFiltersToUrl();

        setSortFilteredRobots(filtered_list);

        if (init) setFilterType("instant");
        else setFilterType("");
    };

    const applyFiltersSchedule = () => {
        if(tickApplyFilter != null) {
            clearTimeout(tickApplyFilter);
        };
        tickApplyFilter = setTimeout(applyFilters, 100);
    };

    const applyFiltersToUrl = () => {
        let hash_str = "";
        let query_symbol = "#filter?";
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        const filter_strings = {
            "brand": brands,
            "axes": axes,
            "tool_weight": tool_weight,
            "application": applications,
        }

        // name
        if(search_input.value.length > 0) {
            hash_str += query_symbol + "name=" + search_input.value.trim().toLowerCase().split(" ").join("+");
            // hash_str += query_symbol + "n=" + search_input.value.trim().toLowerCase().split(" ").join("+");
            query_symbol = "&";
        }

        // checkbox and slider
        Object.keys(filter_strings).map((string) => {
            let temp_hash = editUrlFilter(
                string, 
                filter_strings[string], 
                query_symbol
            );

            if(temp_hash != undefined) {
                hash_str += temp_hash;
                query_symbol = "&";
            }
        });

        // Only change hash when not init because
        // on init the hash is empty and it will reset
        // the hash to empty, this will make the saved urls
        // with filters not working properly
        if(!init) {
            window.location.hash = hash_str;
            window.parent.postMessage( { "hash": window.location.hash } );
        }
    }

    const editUrlFilter = (
        filter_string: string,
        filter: any,
        query_symbol: string,
    ) => {
        if(Array.isArray(filter)) {
            let default_ranges = {
                "reach": [LibData.reachMin, LibData.reachMaxRobot],
                "payload": [LibData.payloadMin, LibData.payloadMaxRobot],
                "tool_weight": [LibData.weightMin, LibData.weightMax],
                "repeatability": [LibData.repeatabilityMin, LibData.repeatabilityMax],
            }

            if (
                filter[0] > default_ranges[filter_string][0] ||
                filter[1] < default_ranges[filter_string][1]
            )
                return query_symbol + filter_string + "=" + filter[0] + "-" + filter[1];

        } else {
            let checked_values = [];
            Object.keys(filter).map((entry) => {
                if (filter[entry]) {
                    let temp_value = entry.trim().toLowerCase().split(" ").join("-");
                    if(temp_value == "ext.-axis") temp_value = "ext.axis"
                    checked_values.push(temp_value);
                }
            });
            if (checked_values.length > 0) {
                return query_symbol + filter_string + "=" + checked_values.join("+");
            }
        }
    };

    const clearFilters = () => {
        setBrands(brandFilter);
        setAxes(axesFilter);
        setWeight([LibData.weightMin, LibData.weightMax]);
        setApplications(applicationFilter);

        setFilterType("instant");
    };

    const clearSearchParameters = () => {
        (document.getElementById("search-input") as HTMLInputElement).value = "";
       
        applyFilters();
        setFilterType("instant");
    };

    // Brand filter
    const handleInputChangeBrandFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_brand_filter = structuredClone(brands);
        new_brand_filter[e.currentTarget.value] = e.currentTarget.checked;

        setBrands(new_brand_filter);
        setFilterType("instant");
    };

    // Axes fitler
    const handleInputChangeNDOFsFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_axes_filter = structuredClone(axes);
        new_axes_filter[e.currentTarget.value] = e.currentTarget.checked;

        setAxes(new_axes_filter);
        setFilterType("instant");
    };

    // Weight filter
    const handleInputChangeRangeWeight = (values: Array<number>) => {
        setWeight([values[0], values[1]]);
        setFilterType("delay");
    };

    // Apps filter
    const handleInputChangeApplicationFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_application_filter = structuredClone(applications);
        new_application_filter[e.currentTarget.value] = e.currentTarget.checked;
        
        setApplications(new_application_filter);
        setFilterType("instant");
    };

    // Retrieve url filters
    // onload for local and direct production version
    React.useEffect(() => {
        setupFilter(hash_message);
        setInit(false);
    }, []);
    
    React.useEffect(() => {
        if(filterType == "delay")
            applyFiltersSchedule()

        else if(filterType == "instant")
            applyFilters();
    });

    const isSticky = useIsDesktop();

    return (
        <>
            {/* <div className="title sticky-top">
                {!hideTab && (
                    <Tab library={"robot"} />
                )}
            </div> */}

            <div className="main-container container-fluid">
                <div className="row">
                    <div className="col col-12 col-sm-12 col-lg-3">
                        <div
                            className={`filter-form ${isSticky ? "sticky-top" : ""}`}
                            style={{ 
                                top: isSticky ? (window.Settings.LOCAL_BUILD ? "8rem" : "12.5rem") : undefined,
                                backgroundColor: "rgb(240, 240, 240)" 
                            }}
                        >
                            <div id="search-row">
                                <form id="search-bar">
                                    <input
                                        id="search-input"
                                        type="text"
                                        placeholder={t('library-headers.search-input')}
                                    />
                                    <div id="search-bar-action-btns">
                                        <button
                                            id="search-button"
                                            onClick={(e: React.MouseEvent) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                applyFilters();
                                            }}
                                        >
                                            <img
                                                width="auto"
                                                height="18rem"
                                                alt="Search"
                                                src={window.Paths.ROBOT_LIB_ASSETS_CDN + "magnifier.png"}
                                            />
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <div className="section-top">
                                <a
                                    className="btn center-block"
                                    style={{ marginLeft: ".5rem" }}
                                    onClick={(e: React.MouseEvent) => {
                                        clearFilters();
                                        clearSearchParameters();
                                    }}
                                >
                                    {t('library-overlays.clearFiltersBtn')}
                                </a>
                            </div>
                            <div className="filters">
                                {!search_params.hasOwnProperty("oem") && (
                                    <Filter 
                                        type = "brands"
                                        title = "filters-robots.brand"
                                        data = {brands}
                                        counts = {filteredToolCounts}
                                        handler = {handleInputChangeBrandFilter}
                                        first = {true}
                                    />
                                )}

                                <Filter 
                                    type = "axes"
                                    title = "filters-robots.axes"
                                    data = {axes}
                                    counts = {filteredToolCounts}
                                    handler = {handleInputChangeNDOFsFilter}
                                    first = {false}
                                />
                                
                                <Filter 
                                    type = "weight"
                                    title = "filters-robots.weight"
                                    step = "0.1"
                                    decimal = "0"
                                    unit = "kg"
                                    data = {tool_weight}
                                    data_default = {[LibData.weightMin, LibData.weightMax]}
                                    handler = {handleInputChangeRangeWeight}
                                    first = {false}
                                />

                                <Filter 
                                    type = "applications"
                                    title = "filters-robots.applications"
                                    data = {applications}
                                    counts = {filteredToolCounts}
                                    handler = {handleInputChangeApplicationFilter}
                                    first = {false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col col-12 col-sm-12 col-lg-9">
                        <ToolLib
                            noToolsMessage = {noToolsMessage}
                            sortFilteredTools = {sortFilteredTools}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
